import PortfolioMobile from 'components/PortfolioMobile';
import Portfolio from '../../components/Portfolio/index';
import { DataTige } from '../../components/Portfolio/data';

export default function Tige() {
  return (
    <>
      <div className="d-none d-lg-block">
        <Portfolio data={DataTige} />
      </div>
      <div className="d-block d-lg-none">
        <PortfolioMobile data={DataTige} />
      </div>
    </>
  );
}
